// extracted by mini-css-extract-plugin
export default {"coupon-action-modal-container":"CouponActionModalContainer_coupon-action-modal-container__ZNc1L"};